import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from './types';

export interface IResponseSerialized {
    headers: Record<string, string>;
    status: number;
    statusText: string;
    body: string;
}

export interface IResponseSerializer {
    serialize: (request: Response) => Promise<IResponseSerialized>;
    parse: (request: IResponseSerialized) => Response;
}

export function injectResponseSerializer(
    container: IContainer = injectOrBuildContainer(),
): IResponseSerializer {
    return container.get<IResponseSerializer>(TYPES.IResponseSerializer);
}

export function bindResponseSerializer(
    val: IResponseSerializer,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IResponseSerializer>(TYPES.IResponseSerializer, val);
}

export function unbindResponseSerializer(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IResponseSerializer);
}
